import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { RouterProvider } from "@tanstack/react-router";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { isConfigured, serviceConfig } from "./config";
import { router } from "./router";
import "./styles.css";

const convexClient = isConfigured(serviceConfig.convex.url)
  ? new ConvexReactClient(serviceConfig.convex.url as string)
  : undefined;

function AppProviders() {
  const app = <RouterProvider router={router} />;
  const isClientReviewPath = window.location.pathname.startsWith("/client-review/");

  if (isClientReviewPath) {
    return convexClient ? <ConvexProvider client={convexClient}>{app}</ConvexProvider> : app;
  }

  if (!serviceConfig.clerk.publishableKey) {
    return convexClient ? <ConvexProvider client={convexClient}>{app}</ConvexProvider> : app;
  }

  if (convexClient) {
    return (
      <ClerkProvider publishableKey={serviceConfig.clerk.publishableKey}>
        <ConvexProviderWithClerk client={convexClient} useAuth={useAuth}>
          {app}
        </ConvexProviderWithClerk>
      </ClerkProvider>
    );
  }

  return <ClerkProvider publishableKey={serviceConfig.clerk.publishableKey}>{app}</ClerkProvider>;
}

const rootElement = document.getElementById("root") as HTMLElement & {
  odcReactRoot?: ReturnType<typeof ReactDOM.createRoot>;
};

const root = rootElement.odcReactRoot ?? ReactDOM.createRoot(rootElement);
rootElement.odcReactRoot = root;

root.render(
  <React.StrictMode>
    <AppProviders />
  </React.StrictMode>,
);
